import React from 'react'

const CodeSnippetIcon = props => {
  const height = props.height || 20
  const width = props.width || 20
  const color = props.color || '#202020'
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(1.333 1.333)" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <path
          d="M2.025 10.064c-1.266.6-2.088 1.689-2.021 3.266 1.577.088 2.665-.756 3.265-2.022M13.33.003S10.355-.153 8.31 1.89C6.268 3.934 1.404 9.42 1.404 9.42l2.51 2.531s5.486-4.886 7.53-6.93C13.486 2.98 13.33.002 13.33.002z"
          stroke={color}
        />
        <circle stroke="#202020" cx="9.333" cy="4.001" r="1" />
        <path
          d="m2.58 8.11 2.666 2.643m-.178-5.42H2.336l-1.71 1.71 2.443.512m4.709.932v2.732l-1.71 1.689-.511-2.421"
          stroke={color}
        />
      </g>
    </svg>
  )
}

export default CodeSnippetIcon
